import React from 'react';
import { useTranslation } from 'react-i18next';

import type Item from '../../@types/item';

import OverflowGrid from '../../components/overflow-grid';
import ProductCard from '../../components/product-card-v2';
import { Column, Columns } from '../../styled-components/components/Columns';
import { Container } from '../../styled-components/components/Container';
import { H3 } from '../../styled-components/components/Heading';
import { Link } from '../../styled-components/components/Link';
import { PageSection } from '../../styled-components/components/Page';
import { VStack } from '../../styled-components/components/VStack';

interface IProps {
  items: Item[];
  similarLink: string;
}

const MostSimilarItems = ({ items, similarLink }: IProps) => {
  const { t } = useTranslation('error');

  return (
    <PageSection>
      <Container>
        <VStack $spacing={2}>
          <Columns $spacing={2} $valign="center">
            <Column $grow>
              <H3 as="h2" $margin="none">
                {t('similarCars', { ns: 'error' })}
              </H3>
            </Column>
            {!!similarLink && (
              <Column $noShrink>
                <Link href={similarLink} title={t('seeAllSimilarCarsTitle', { ns: 'error' })}>
                  {t('seeAllSimilarCars', { ns: 'error' })}
                </Link>
              </Column>
            )}
          </Columns>
          <OverflowGrid visibleItems={3}>
            {items.slice(0, 3).map((item, index) => (
              <div key={`${item.id}-${index}`} className="overflow-grid-item">
                <div className="overflow-grid-content">
                  <ProductCard item={item} />
                </div>
              </div>
            ))}
          </OverflowGrid>
        </VStack>
      </Container>
    </PageSection>
  );
};

export default MostSimilarItems;
